<a
    class="w-full flex flex-col items-center justify-center hover:bg-blurple rounded-lg"
    routerLink="/help"
    routerLinkActive="!bg-blurple-dark"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    pTooltip="Help and Resources"
    tooltipPosition="right"
    #link="routerLinkActive">
    <fa-icon
        class="text-18 text-white"
        [icon]="faCircleQuestion"
        [ngClass]="{ hidden: isHovered || link.isActive }" />
    <fa-icon
        class="text-18 text-white"
        [icon]="faCircleQuestionSolid"
        [ngClass]="{ hidden: !isHovered && !link.isActive }" />
</a>
